const defaultState = {
    flowQueue: [],
    currentPageIndex: 0,
    trackingPrefix: '',
    flow: null,
    tabs: null,
};

const state = defaultState;

const mutations = {
    resetState: state => Object.assign(state, defaultState),
    setTrackingPrefix: (state, variant) => state.trackingPrefix = variant,
    incrementCurrentPageIndex: state => state.currentPageIndex++,
    decrementCurrentPageIndex: state => state.currentPageIndex--,
    setSpecificPageIndex: (state, index) => state.currentPageIndex = index,
    pushToFlowQueue: (state, flow) => state.flowQueue.push({ ...flow }),
    setFlow: (state, flow) => {
        // On initial load state.flow is null, we want it to be an empty object
        if (!state.flow) state.flow = {};
        Object.assign(state.flow, { ...flow });
    },
    setTabs: (state, tabs) => state.tabs = tabs,
};

const actions = {
    resetState: ({ commit }) => commit('resetState'),
    setTrackingPrefix: ({ commit }, variant) => commit('setTrackingPrefix', variant),
    incrementCurrentPageIndex: ({ commit }) => commit('incrementCurrentPageIndex'),
    decrementCurrentPageIndex: ({ commit }) => commit('decrementCurrentPageIndex'),
    setSpecificPageIndex: ({ commit }, index) => commit('setSpecificPageIndex', index),
    pushToFlowQueue: ({ commit }, flow) => commit('pushToFlowQueue', flow),
    setFlow: ({ commit }, flow) => commit('setFlow', flow),
    setTabs: ({ commit }, tabs) => commit('setTabs', tabs),
};

const getters = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
